import { Components, Theme } from '@mui/material';

export const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: {
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingTop: '12px',
      paddingBottom: '12px',
      color: '#263238',
      fontSize: 16,
      fontWeight: 500,
      lineHeight: '24px',
      '&:hover': {
        backgroundColor: 'rgba(25, 181, 210, 0.08)',
      },
      '&.Mui-selected': {
        backgroundColor: 'rgba(25, 181, 210, 0.16)',
        '&:hover': {
          backgroundColor: 'rgba(25, 181, 210, 0.24)',
        },
      },
    },
  },
};
